exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .modal-body input,\n.modal .modal-body textarea {\n  border-color: transparent;\n  background: #f5f5f5;\n  resize: none;\n}\n.modal .modal-footer .btn + .btn {\n  margin-left: 5px;\n  padding: 10px 20px;\n}\n@media (max-width: 767px) {\n.modal .modal-footer .btn {\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 5px;\n}\n}\n", ""]);

// exports
